import React from 'react'
import { connect } from 'react-redux'
import { Route, Redirect } from 'react-router-dom'

const PublicClientRoute = ({
	isAuthenticated,
	component: Component,
	client,
	...rest
}) => {
	return (
		<Route
			{...rest}
			component={(props) =>
				isAuthenticated ? (
					<Redirect to='/client/client_dashboard' />
				) : (
					<Component {...props} />
				)
			}
		/>
	)
}

const mapStateToProps = (state) => ({
	client: state.app.client,
	isAuthenticated: !!state.app.client,
})

export default connect(mapStateToProps)(PublicClientRoute)
